angular.module('picmonicng').filter('removeDrag', [
  function () {
    return function (input, card) {
      if (card && input && input.indexOf(card) !== -1) {
        input.splice(input.indexOf(card), 1);
      }
      return input;
    };
  },
]);
